<script>
  export default {
    name: 'TabletFrame',
  };
</script>

<template>
  <div ref="frame" class="frame">
    <div class="frame__content">
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
.frame {
  --pading-top-size: 1.25rem;
  @apply w-full overflow-hidden relative bg-white border border-50 px-3 py-10;
  width: 351px;
  height: 505px;
  border-radius: 1.6rem;
  transform-origin: top center;
}

.frame__content {
  @apply w-full h-full border border-50 overflow-hidden rounded-lg;
}

.frame__content::before {
  --half-width-size: 0.25rem;
  @apply absolute w-2 h-2 bg-white border border-60 rounded-full mx-auto;
  content: "";
  top: calc(var(--pading-top-size) - var(--half-width-size));
  left: calc(50% - var(--half-width-size));
}

.frame__content::after {
  --half-width-size: 0.75rem;
  @apply absolute w-6 h-6 bg-white border border-60 rounded-full mx-auto;
  content: "";
  bottom: calc(var(--pading-top-size) - var(--half-width-size));
  left: calc(50% - var(--half-width-size));
}

.frame__content > div {
  @apply w-full h-full overflow-x-hidden overflow-y-scroll overflow-x-hidden;
  transform: scale(0.7);
  transform-origin: 0 0;
  box-sizing: border-box;
  width: 142.85%; /* 100 / 0.6 */
  height: 142.85%;
}
</style>
